function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { getUrlRegExp, isIncluded, getBucketRanges, hash, chooseVariation, getQueryStringOverride, inNamespace } from "./util";
import { evalCondition } from "./mongrule";
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";

var base64ToBuf = function base64ToBuf(b) {
  return Uint8Array.from(atob(b), function (c) {
    return c.charCodeAt(0);
  });
};

export var GrowthBook = /*#__PURE__*/function () {
  // eslint-disable-next-line
  function GrowthBook() {
    _classCallCheck(this, GrowthBook);

    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _defineProperty(this, "_renderer", null);

    _defineProperty(this, "_trackedExperiments", new Set());

    _defineProperty(this, "_trackedFeatures", {});

    _defineProperty(this, "debug", false);

    _defineProperty(this, "subscriptions", new Set());

    _defineProperty(this, "_rtQueue", []);

    _defineProperty(this, "_rtTimer", 0);

    _defineProperty(this, "assigned", new Map());

    _defineProperty(this, "_forcedFeatureValues", new Map());

    _defineProperty(this, "_attributeOverrides", {});

    this.context = context;

    if (isBrowser && context.enableDevMode) {
      window._growthbook = this;
      document.dispatchEvent(new Event("gbloaded"));
    }
  }

  _createClass(GrowthBook, [{
    key: "render",
    value: function render() {
      if (this._renderer) {
        this._renderer();
      }
    }
  }, {
    key: "setFeatures",
    value: function setFeatures(features) {
      this.context.features = features;
      this.render();
    }
  }, {
    key: "setEncryptedFeatures",
    value: function () {
      var _setEncryptedFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(encryptedString, encryptionKey, subtle) {
        var key, _encryptedString$spli, _encryptedString$spli2, iv, cipherText, plainTextBuffer;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                subtle = subtle || globalThis.crypto && globalThis.crypto.subtle;

                if (subtle) {
                  _context.next = 3;
                  break;
                }

                throw new Error("No SubtleCrypto implementation found");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return subtle.importKey("raw", base64ToBuf(encryptionKey), {
                  name: "AES-CBC",
                  length: 128
                }, true, ["encrypt", "decrypt"]);

              case 6:
                key = _context.sent;
                _encryptedString$spli = encryptedString.split("."), _encryptedString$spli2 = _slicedToArray(_encryptedString$spli, 2), iv = _encryptedString$spli2[0], cipherText = _encryptedString$spli2[1];
                _context.next = 10;
                return subtle.decrypt({
                  name: "AES-CBC",
                  iv: base64ToBuf(iv)
                }, key, base64ToBuf(cipherText));

              case 10:
                plainTextBuffer = _context.sent;
                this.setFeatures(JSON.parse(new TextDecoder().decode(plainTextBuffer)));
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);
                throw new Error("Failed to decrypt features");

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 14]]);
      }));

      function setEncryptedFeatures(_x, _x2, _x3) {
        return _setEncryptedFeatures.apply(this, arguments);
      }

      return setEncryptedFeatures;
    }()
  }, {
    key: "setAttributes",
    value: function setAttributes(attributes) {
      this.context.attributes = attributes;
      this.render();
    }
  }, {
    key: "setAttributeOverrides",
    value: function setAttributeOverrides(overrides) {
      this._attributeOverrides = overrides;
      this.render();
    }
  }, {
    key: "setForcedVariations",
    value: function setForcedVariations(vars) {
      this.context.forcedVariations = vars || {};
      this.render();
    } // eslint-disable-next-line

  }, {
    key: "setForcedFeatures",
    value: function setForcedFeatures(map) {
      this._forcedFeatureValues = map;
      this.render();
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return _objectSpread(_objectSpread({}, this.context.attributes), this._attributeOverrides);
    }
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      return this.context.features || {};
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      var _this = this;

      this.subscriptions.add(cb);
      return function () {
        _this.subscriptions.delete(cb);
      };
    }
  }, {
    key: "getAllResults",
    value: function getAllResults() {
      return new Map(this.assigned);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // Release references to save memory
      this.subscriptions.clear();
      this.assigned.clear();

      this._trackedExperiments.clear();

      this._trackedFeatures = {};
      this._rtQueue = [];

      if (this._rtTimer) {
        clearTimeout(this._rtTimer);
      }

      if (isBrowser && window._growthbook === this) {
        delete window._growthbook;
      }
    }
  }, {
    key: "setRenderer",
    value: function setRenderer(renderer) {
      this._renderer = renderer;
    }
  }, {
    key: "forceVariation",
    value: function forceVariation(key, variation) {
      this.context.forcedVariations = this.context.forcedVariations || {};
      this.context.forcedVariations[key] = variation;
      this.render();
    }
  }, {
    key: "run",
    value: function run(experiment) {
      var result = this._run(experiment, null);

      this.fireSubscriptions(experiment, result);
      return result;
    }
  }, {
    key: "fireSubscriptions",
    value: function fireSubscriptions(experiment, result) {
      var key = experiment.key; // If assigned variation has changed, fire subscriptions

      var prev = this.assigned.get(key); // TODO: what if the experiment definition has changed?

      if (!prev || prev.result.inExperiment !== result.inExperiment || prev.result.variationId !== result.variationId) {
        this.assigned.set(key, {
          experiment: experiment,
          result: result
        });
        this.subscriptions.forEach(function (cb) {
          try {
            cb(experiment, result);
          } catch (e) {
            console.error(e);
          }
        });
      }
    }
  }, {
    key: "trackFeatureUsage",
    value: function trackFeatureUsage(key, res) {
      var _this2 = this;

      // Don't track feature usage that was forced via an override
      if (res.source === "override") return; // Only track a feature once, unless the assigned value changed

      var stringifiedValue = JSON.stringify(res.value);
      if (this._trackedFeatures[key] === stringifiedValue) return;
      this._trackedFeatures[key] = stringifiedValue; // Fire user-supplied callback

      if (this.context.onFeatureUsage) {
        try {
          this.context.onFeatureUsage(key, res);
        } catch (e) {// Ignore feature usage callback errors
        }
      } // In browser environments, queue up feature usage to be tracked in batches


      if (!isBrowser || !window.fetch) return;

      this._rtQueue.push({
        key: key,
        on: res.on
      });

      if (!this._rtTimer) {
        this._rtTimer = window.setTimeout(function () {
          // Reset the queue
          _this2._rtTimer = 0;

          var q = _toConsumableArray(_this2._rtQueue);

          _this2._rtQueue = []; // Skip logging if a real-time usage key is not configured

          if (!_this2.context.realtimeKey) return;
          window.fetch("https://rt.growthbook.io/?key=".concat(_this2.context.realtimeKey, "&events=").concat(encodeURIComponent(JSON.stringify(q))), {
            cache: "no-cache",
            mode: "no-cors"
          }).catch(function () {// TODO: retry in case of network errors?
          });
        }, this.context.realtimeInterval || 2000);
      }
    }
  }, {
    key: "getFeatureResult",
    value: function getFeatureResult(key, value, source, ruleId) {
      var experiment = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var result = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var ret = {
        value: value,
        on: !!value,
        off: !value,
        source: source,
        ruleId: ruleId || ""
      };
      if (experiment) ret.experiment = experiment;
      if (result) ret.experimentResult = result; // Track the usage of this feature in real-time

      this.trackFeatureUsage(key, ret);
      return ret;
    }
  }, {
    key: "isOn",
    value: function isOn(key) {
      return this.evalFeature(key).on;
    }
  }, {
    key: "isOff",
    value: function isOff(key) {
      return this.evalFeature(key).off;
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue) {
      var _this$evalFeature$val;

      return (_this$evalFeature$val = this.evalFeature(key).value) !== null && _this$evalFeature$val !== void 0 ? _this$evalFeature$val : defaultValue;
    } // eslint-disable-next-line

  }, {
    key: "feature",
    value: function feature(id) {
      return this.evalFeature(id);
    } // eslint-disable-next-line

  }, {
    key: "evalFeature",
    value: function evalFeature(id) {
      var _feature$defaultValue, _feature$defaultValue2; // Global override


      if (this._forcedFeatureValues.has(id)) {
        process.env.NODE_ENV !== "production" && this.log("Global override", {
          id: id,
          value: this._forcedFeatureValues.get(id)
        });
        return this.getFeatureResult(id, this._forcedFeatureValues.get(id), "override");
      } // Unknown feature id


      if (!this.context.features || !this.context.features[id]) {
        process.env.NODE_ENV !== "production" && this.log("Unknown feature", {
          id: id
        });
        return this.getFeatureResult(id, null, "unknownFeature");
      } // Get the feature


      var feature = this.context.features[id]; // Loop through the rules

      if (feature.rules) {
        var _iterator = _createForOfIteratorHelper(feature.rules),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var rule = _step.value;

            // If it's a conditional rule, skip if the condition doesn't pass
            if (rule.condition && !this.conditionPasses(rule.condition)) {
              process.env.NODE_ENV !== "production" && this.log("Skip rule because of condition", {
                id: id,
                rule: rule
              });
              continue;
            } // Feature value is being forced


            if ("force" in rule) {
              // Skip if coverage is reduced and user not included
              if ("coverage" in rule) {
                var _this$getHashAttribut = this.getHashAttribute(rule.hashAttribute),
                    hashValue = _this$getHashAttribut.hashValue;

                if (!hashValue) {
                  process.env.NODE_ENV !== "production" && this.log("Skip rule because of missing hashAttribute", {
                    id: id,
                    rule: rule
                  });
                  continue;
                }

                var n = hash(hashValue + id);

                if (n > rule.coverage) {
                  process.env.NODE_ENV !== "production" && this.log("Skip rule because of coverage", {
                    id: id,
                    rule: rule
                  });
                  continue;
                }
              }

              process.env.NODE_ENV !== "production" && this.log("Force value from rule", {
                id: id,
                rule: rule
              }); // eslint-disable-next-line

              return this.getFeatureResult(id, rule.force, "force", rule.id);
            }

            if (!rule.variations) {
              process.env.NODE_ENV !== "production" && this.log("Skip invalid rule", {
                id: id,
                rule: rule
              });
              continue;
            } // For experiment rules, run an experiment


            var exp = {
              variations: rule.variations,
              key: rule.key || id
            };
            if ("coverage" in rule) exp.coverage = rule.coverage;
            if (rule.weights) exp.weights = rule.weights;
            if (rule.hashAttribute) exp.hashAttribute = rule.hashAttribute;
            if (rule.namespace) exp.namespace = rule.namespace; // Only return a value if the user is part of the experiment

            var res = this._run(exp, id);

            this.fireSubscriptions(exp, res);

            if (res.inExperiment) {
              return this.getFeatureResult(id, res.value, "experiment", rule.id, exp, res);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      process.env.NODE_ENV !== "production" && this.log("Use default value", {
        id: id,
        value: (_feature$defaultValue = feature.defaultValue) !== null && _feature$defaultValue !== void 0 ? _feature$defaultValue : null
      }); // Fall back to using the default value

      return this.getFeatureResult(id, (_feature$defaultValue2 = feature.defaultValue) !== null && _feature$defaultValue2 !== void 0 ? _feature$defaultValue2 : null, "defaultValue");
    }
  }, {
    key: "conditionPasses",
    value: function conditionPasses(condition) {
      return evalCondition(this.getAttributes(), condition);
    }
  }, {
    key: "_run",
    value: function _run(experiment, featureId) {
      var key = experiment.key;
      var numVariations = experiment.variations.length; // 1. If experiment has less than 2 variations, return immediately

      if (numVariations < 2) {
        process.env.NODE_ENV !== "production" && this.log("Invalid experiment", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 2. If the context is disabled, return immediately


      if (this.context.enabled === false) {
        process.env.NODE_ENV !== "production" && this.log("Context disabled", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 2.5. Merge in experiment overrides from the context


      experiment = this.mergeOverrides(experiment); // 3. If a variation is forced from a querystring, return the forced variation

      var qsOverride = getQueryStringOverride(key, this.getContextUrl(), numVariations);

      if (qsOverride !== null) {
        process.env.NODE_ENV !== "production" && this.log("Force via querystring", {
          id: key,
          variation: qsOverride
        });
        return this.getResult(experiment, qsOverride, false, featureId);
      } // 4. If a variation is forced in the context, return the forced variation


      if (this.context.forcedVariations && key in this.context.forcedVariations) {
        var variation = this.context.forcedVariations[key];
        process.env.NODE_ENV !== "production" && this.log("Force via dev tools", {
          id: key,
          variation: variation
        });
        return this.getResult(experiment, variation, false, featureId);
      } // 5. Exclude if a draft experiment or not active


      if (experiment.status === "draft" || experiment.active === false) {
        process.env.NODE_ENV !== "production" && this.log("Skip because inactive", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 6. Get the hash attribute and return if empty


      var _this$getHashAttribut2 = this.getHashAttribute(experiment.hashAttribute),
          hashValue = _this$getHashAttribut2.hashValue;

      if (!hashValue) {
        process.env.NODE_ENV !== "production" && this.log("Skip because missing hashAttribute", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 7. Exclude if user not in experiment.namespace


      if (experiment.namespace && !inNamespace(hashValue, experiment.namespace)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of namespace", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 7.5. Exclude if experiment.include returns false or throws


      if (experiment.include && !isIncluded(experiment.include)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of include function", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 8. Exclude if condition is false


      if (experiment.condition && !this.conditionPasses(experiment.condition)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of condition", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 8.1. Exclude if user is not in a required group


      if (experiment.groups && !this.hasGroupOverlap(experiment.groups)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of groups", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 8.2. Exclude if not on a targeted url


      if (experiment.url && !this.urlIsValid(experiment.url)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of url", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 9. Get bucket ranges and choose variation


      var ranges = getBucketRanges(numVariations, experiment.coverage || 1, experiment.weights);
      var n = hash(hashValue + key);
      var assigned = chooseVariation(n, ranges); // 10. Return if not in experiment

      if (assigned < 0) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of coverage", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 11. Experiment has a forced variation


      if ("force" in experiment) {
        var _experiment$force;

        process.env.NODE_ENV !== "production" && this.log("Force variation", {
          id: key,
          variation: experiment.force
        });
        return this.getResult(experiment, (_experiment$force = experiment.force) !== null && _experiment$force !== void 0 ? _experiment$force : -1, false, featureId);
      } // 12. Exclude if in QA mode


      if (this.context.qaMode) {
        process.env.NODE_ENV !== "production" && this.log("Skip because QA mode", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 12.5. Exclude if experiment is stopped


      if (experiment.status === "stopped") {
        process.env.NODE_ENV !== "production" && this.log("Skip because stopped", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      } // 13. Build the result object


      var result = this.getResult(experiment, assigned, true, featureId); // 14. Fire the tracking callback

      this.track(experiment, result); // 15. Return the result

      process.env.NODE_ENV !== "production" && this.log("In experiment", {
        id: key,
        variation: result.variationId
      });
      return result;
    } // eslint-disable-next-line

  }, {
    key: "log",
    value: function log(msg, ctx) {
      if (!this.debug) return;
      if (this.context.log) this.context.log(msg, ctx);else console.log(msg, ctx);
    }
  }, {
    key: "track",
    value: function track(experiment, result) {
      if (!this.context.trackingCallback) return;
      var key = experiment.key; // Make sure a tracking callback is only fired once per unique experiment

      var k = result.hashAttribute + result.hashValue + key + result.variationId;
      if (this._trackedExperiments.has(k)) return;

      this._trackedExperiments.add(k);

      try {
        this.context.trackingCallback(experiment, result);
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "mergeOverrides",
    value: function mergeOverrides(experiment) {
      var key = experiment.key;
      var o = this.context.overrides;

      if (o && o[key]) {
        experiment = Object.assign({}, experiment, o[key]);

        if (typeof experiment.url === "string") {
          experiment.url = getUrlRegExp( // eslint-disable-next-line
          experiment.url);
        }
      }

      return experiment;
    }
  }, {
    key: "getHashAttribute",
    value: function getHashAttribute(attr) {
      var hashAttribute = attr || "id";
      var hashValue = "";

      if (this._attributeOverrides[hashAttribute]) {
        hashValue = this._attributeOverrides[hashAttribute];
      } else if (this.context.attributes) {
        hashValue = this.context.attributes[hashAttribute] || "";
      } else if (this.context.user) {
        hashValue = this.context.user[hashAttribute] || "";
      }

      return {
        hashAttribute: hashAttribute,
        hashValue: hashValue
      };
    }
  }, {
    key: "getResult",
    value: function getResult(experiment, variationIndex, hashUsed, featureId) {
      var inExperiment = true; // If assigned variation is not valid, use the baseline and mark the user as not in the experiment

      if (variationIndex < 0 || variationIndex >= experiment.variations.length) {
        variationIndex = 0;
        inExperiment = false;
      }

      var _this$getHashAttribut3 = this.getHashAttribute(experiment.hashAttribute),
          hashAttribute = _this$getHashAttribut3.hashAttribute,
          hashValue = _this$getHashAttribut3.hashValue;

      return {
        featureId: featureId,
        inExperiment: inExperiment,
        hashUsed: hashUsed,
        variationId: variationIndex,
        value: experiment.variations[variationIndex],
        hashAttribute: hashAttribute,
        hashValue: hashValue
      };
    }
  }, {
    key: "getContextUrl",
    value: function getContextUrl() {
      return this.context.url || (isBrowser ? window.location.href : "");
    }
  }, {
    key: "urlIsValid",
    value: function urlIsValid(urlRegex) {
      var url = this.getContextUrl();
      if (!url) return false;
      var pathOnly = url.replace(/^https?:\/\//, "").replace(/^[^/]*\//, "/");
      if (urlRegex.test(url)) return true;
      if (urlRegex.test(pathOnly)) return true;
      return false;
    }
  }, {
    key: "hasGroupOverlap",
    value: function hasGroupOverlap(expGroups) {
      var groups = this.context.groups || {};

      for (var i = 0; i < expGroups.length; i++) {
        if (groups[expGroups[i]]) return true;
      }

      return false;
    }
  }]);

  return GrowthBook;
}();